import {
  iHolidayQuoteContentBlocks,
  iTrustPilotBlockData,
} from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { iBrand } from "@/@sdk/brands/brand-model";

export function buildPreviewTrustPilotBlock(
  brand?: iBrand | null
): iHolidayQuoteContentBlocks | null {
  const trustPilotData = resolveTrustPilotBlockData(brand);
  if (!trustPilotData?.businessUnitId || !trustPilotData?.templateId) {
    return null;
  }

  return {
    id: "preview-trustpilot",
    type: "trustpilot_reviews",
    title: "",
    body: "",
    gallery: [],
    trustPilotData,
  };
}

export function buildPreviewCustomTemplateBlock(
  brand?: iBrand | null
): iHolidayQuoteContentBlocks | null {
  const template = brand?.customContentBlocksConfig?.blocks?.[0];
  if (!template?.html) {
    return null;
  }

  return {
    id: "preview-custom-template",
    type: "custom_template_block",
    title: template.name,
    body: "",
    gallery: [],
    customTemplateBlockData: {
      templateId: template.id,
      templateName: template.name,
      html: template.html,
    },
  };
}

export function buildPreviewAgentDataBlock(
  agentName: string
): iHolidayQuoteContentBlocks {
  return {
    id: "preview-agent-data",
    type: "agent_data",
    title: "",
    body: "",
    gallery: [],
    agentData: {
      customMessage: `<p>The Maldives is everything you imagine and more — powder-soft sand, crystal-clear lagoons, and evenings spent watching the sun melt into the Indian Ocean from your private overwater deck.</p>
<p>The Sheraton Full Moon Resort sits on its own island in the North Malé Atoll, combining world-class dining with the warmth and intimacy that makes a honeymoon truly special. Whether you are snorkelling alongside tropical fish, enjoying a couples' spa treatment, or simply doing nothing at all, this is the escape you deserve.</p>
<p>I have personally inspected this resort and can vouch for the quality of the overwater villas, the all-inclusive programme, and the seamless transfer experience from the moment you land.</p>
<p>As always, I am here for any adjustments or additions you may need along the way — just reply to this quote or give me a call.</p>
<p>Looking forward to helping you confirm this wonderful trip,<br/><strong>${agentName}</strong></p>`,
    },
  };
}

function resolveTrustPilotBlockData(
  brand?: iBrand | null
): iTrustPilotBlockData | null {
  const config = brand?.trustPilotConfig;
  if (!config) {
    return null;
  }

  const preset = config.widgetPresets?.[0];
  if (preset) {
    return {
      selectedPresetId: preset.id,
      businessUnitId: preset.businessUnitId,
      templateId: preset.templateId,
      widgetHeight: preset.widgetHeight,
    };
  }

  if (config.businessUnitId && config.templateId) {
    return {
      businessUnitId: config.businessUnitId,
      templateId: config.templateId,
      widgetHeight: config.widgetHeight ?? 240,
    };
  }

  return null;
}
